'use strict';

var React = require('react');
var Module = require('./Module.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Body = ({ sections, enablePreviewMode, ModulePreviewTooling }) => (React__default["default"].createElement(React__default["default"].Fragment, null, sections.map((section, index) => (React__default["default"].createElement(Module, { key: `${section.name}-${index}`, index: index, uiComponentIdentifier: section.uiComponentIdentifier, enablePreviewMode: enablePreviewMode, displayOrder: section.displayOrder, ModulePreviewTooling: ModulePreviewTooling, ...section.context })))));

module.exports = Body;
//# sourceMappingURL=Body.js.map
